// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__I_W3i","name":"Header_name__2y5IV","birthday":"Header_birthday__zGaA5","skeleton":"Header_skeleton__CAGiS"};